// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main_mainContainer__8Fd1y {
    height: 100%;
    background-color: #F4F5FA;
}

.main_container__9fgCb {
    padding-top: var(--app-header-height, 60px);
    padding-left: 0.9rem;
    margin-left: 285px;
    margin-right: 1rem;
    box-sizing: border-box;
    transition: margin-left 0.28s cubic-bezier(0.4, 0, 0.2, 1);
}

.main_filterContainer__NkhV7 {
    background-color: #FFFFFF;
    border-radius: 6px;
    padding: 14px 24px 8px 24px;
    text-align: left;
    font-size: large;
    width: 100%;
}

.main_secondaryContainer__qFwxo {
    background-color: #FFFFFF;
    border-radius: 6px;
    padding: 10px 24px;
    text-align: left;
    color: #3A3541;
    opacity: 80%;
}

.main_downloadButton__F0nq9 {
    border: solid 1px black;
    width: 70px;
    padding-top: 1px;
    padding-bottom: 1px;
    text-align: center;
    border-radius: 8px;
    margin-left: 1rem;
    cursor: pointer;
}

.main_downloadButton__F0nq9:hover {
    background-color: #FAFAFA;
}

.main_pill__w7JkR {
    background-color: #4A4DB9;
    text-align: center;
    color: #FFFFFF;
    padding: 2px 8px;
    border-radius: 10px;
    -webkit-user-select: none;
            user-select: none;
}

.main_observationField__OrSAN {
    background-color: #D9D9D9;
    border-radius: 6px;
}

.main_modalSubtitle__yQF78 {
    color: #3A3541;
    font-size: 24px;
}

.main_modalSmallSubtitle__UTiFM {
    color: rgba(51, 51, 51, 80%);
    font-size: 16px;
}

.main_modalButton__nJSra {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-left: 1rem;
    margin-bottom: 1rem;
    padding: 6px 18px 6px 18px;
    border-radius: 6px;
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
    color: #FFFFFF;
    text-align: center;
    align-items: center;
}

.main_redButton__GebOK {
    margin-right: 0.5rem;
    padding: 6px 12px 6px 12px;
    border-radius: 6px;
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
    color: #FFFFFF;
    text-align: center;
    background-color: #DC3545;
}

.main_secondarySearch__15L3X {
    border: 0;
    border-bottom: 1px solid #ccc;
}

.main_secondarySearch__15L3X:focus {
    border: 0;
    border-bottom: 1px solid #13acec;
    outline: none !important;
    box-shadow: none !important;
}

/* Grid */

.main_invoiceGrid__OrgrH {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 0 4px;
}

/* Invoice tables */

.main_invoiceTable__Mw4\\+O {
    width: 100%;
    border-collapse: collapse;
    border: 1px solid #000;
    font-family: Arial, sans-serif;
    font-size: 14px;
}

.main_invoiceTable__Mw4\\+O th,
.main_invoiceTable__Mw4\\+O td {
    border: 1px solid #000;
    padding: 8px 10px;
    text-align: left;
}

.main_invoiceTable__Mw4\\+O thead {
    background-color: #f0f0f0;
    font-weight: bold;
}

.main_invoiceTable__Mw4\\+O tbody tr:nth-child(even) {
    background-color: #fafafa;
}

.main_invoiceTable__Mw4\\+O tbody tr:hover {
    background-color: #f5f5f5;
}`, "",{"version":3,"sources":["webpack://./src/styles/main.module.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,2CAA2C;IAC3C,oBAAoB;IACpB,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;IACtB,0DAA0D;AAC9D;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,2BAA2B;IAC3B,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,4BAA4B;IAC5B,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,0BAA0B;IAC1B,kBAAkB;IAClB,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,0BAA0B;IAC1B,kBAAkB;IAClB,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,SAAS;IACT,6BAA6B;AACjC;;AAEA;IACI,SAAS;IACT,gCAAgC;IAChC,wBAAwB;IACxB,2BAA2B;AAC/B;;AAEA,SAAS;;AAET;IACI,aAAa;IACb,qCAAqC;IACrC,UAAU;AACd;;AAEA,mBAAmB;;AAEnB;IACI,WAAW;IACX,yBAAyB;IACzB,sBAAsB;IACtB,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;;IAEI,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".mainContainer {\n    height: 100%;\n    background-color: #F4F5FA;\n}\n\n.container {\n    padding-top: var(--app-header-height, 60px);\n    padding-left: 0.9rem;\n    margin-left: 285px;\n    margin-right: 1rem;\n    box-sizing: border-box;\n    transition: margin-left 0.28s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.filterContainer {\n    background-color: #FFFFFF;\n    border-radius: 6px;\n    padding: 14px 24px 8px 24px;\n    text-align: left;\n    font-size: large;\n    width: 100%;\n}\n\n.secondaryContainer {\n    background-color: #FFFFFF;\n    border-radius: 6px;\n    padding: 10px 24px;\n    text-align: left;\n    color: #3A3541;\n    opacity: 80%;\n}\n\n.downloadButton {\n    border: solid 1px black;\n    width: 70px;\n    padding-top: 1px;\n    padding-bottom: 1px;\n    text-align: center;\n    border-radius: 8px;\n    margin-left: 1rem;\n    cursor: pointer;\n}\n\n.downloadButton:hover {\n    background-color: #FAFAFA;\n}\n\n.pill {\n    background-color: #4A4DB9;\n    text-align: center;\n    color: #FFFFFF;\n    padding: 2px 8px;\n    border-radius: 10px;\n    user-select: none;\n}\n\n.observationField {\n    background-color: #D9D9D9;\n    border-radius: 6px;\n}\n\n.modalSubtitle {\n    color: #3A3541;\n    font-size: 24px;\n}\n\n.modalSmallSubtitle {\n    color: rgba(51, 51, 51, 80%);\n    font-size: 16px;\n}\n\n.modalButton {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-left: 1rem;\n    margin-bottom: 1rem;\n    padding: 6px 18px 6px 18px;\n    border-radius: 6px;\n    cursor: pointer;\n    user-select: none;\n    color: #FFFFFF;\n    text-align: center;\n    align-items: center;\n}\n\n.redButton {\n    margin-right: 0.5rem;\n    padding: 6px 12px 6px 12px;\n    border-radius: 6px;\n    cursor: pointer;\n    user-select: none;\n    color: #FFFFFF;\n    text-align: center;\n    background-color: #DC3545;\n}\n\n.secondarySearch {\n    border: 0;\n    border-bottom: 1px solid #ccc;\n}\n\n.secondarySearch:focus {\n    border: 0;\n    border-bottom: 1px solid #13acec;\n    outline: none !important;\n    box-shadow: none !important;\n}\n\n/* Grid */\n\n.invoiceGrid {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 0 4px;\n}\n\n/* Invoice tables */\n\n.invoiceTable {\n    width: 100%;\n    border-collapse: collapse;\n    border: 1px solid #000;\n    font-family: Arial, sans-serif;\n    font-size: 14px;\n}\n\n.invoiceTable th,\n.invoiceTable td {\n    border: 1px solid #000;\n    padding: 8px 10px;\n    text-align: left;\n}\n\n.invoiceTable thead {\n    background-color: #f0f0f0;\n    font-weight: bold;\n}\n\n.invoiceTable tbody tr:nth-child(even) {\n    background-color: #fafafa;\n}\n\n.invoiceTable tbody tr:hover {\n    background-color: #f5f5f5;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainContainer": `main_mainContainer__8Fd1y`,
	"container": `main_container__9fgCb`,
	"filterContainer": `main_filterContainer__NkhV7`,
	"secondaryContainer": `main_secondaryContainer__qFwxo`,
	"downloadButton": `main_downloadButton__F0nq9`,
	"pill": `main_pill__w7JkR`,
	"observationField": `main_observationField__OrSAN`,
	"modalSubtitle": `main_modalSubtitle__yQF78`,
	"modalSmallSubtitle": `main_modalSmallSubtitle__UTiFM`,
	"modalButton": `main_modalButton__nJSra`,
	"redButton": `main_redButton__GebOK`,
	"secondarySearch": `main_secondarySearch__15L3X`,
	"invoiceGrid": `main_invoiceGrid__OrgrH`,
	"invoiceTable": `main_invoiceTable__Mw4+O`
};
export default ___CSS_LOADER_EXPORT___;
